import cx from "classnames";

import { Skeleton } from "common/ui/Skeleton";

import styles from "./Badge.module.scss";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean;
}

export function Badge({ children, className, isLoading, ...rest }: BadgeProps) {
  if (isLoading) {
    return <Skeleton height={28} width={160} />;
  }

  return (
    <div
      className={cx(styles.Badge, className)}
      {...rest}
    >
      {children}
    </div>
  )
}
